import { render, staticRenderFns } from "./UnavailableFeature.vue?vue&type=template&id=6f85e1db&scoped=true"
import script from "./UnavailableFeature.vue?vue&type=script&lang=js"
export * from "./UnavailableFeature.vue?vue&type=script&lang=js"
import style0 from "./UnavailableFeature.vue?vue&type=style&index=0&id=6f85e1db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f85e1db",
  null
  
)

export default component.exports